import * as React from "react";
import { cn } from "@/lib/utils";

interface AgeGroupBadgeProps {
  ageGroup: string;
  className?: string;
  testId?: string;
}

export function AgeGroupBadge({ ageGroup, className, testId }: AgeGroupBadgeProps) {
  // Determine style based on age group
  let badgeStyle = "bg-neutral-800 text-neutral-300 border-neutral-700";
  
  if (ageGroup === "5-8 years") {
    badgeStyle = "bg-sky-900/60 text-sky-300 border-sky-700/60";
  } else if (ageGroup === "8+ years") {
    badgeStyle = "bg-emerald-900/60 text-emerald-300 border-emerald-700/60";
  }

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-1 text-xs font-medium border",
        badgeStyle,
        className
      )}
      data-testid={testId}
    >
      {ageGroup}
    </span>
  );
}
